import { Flex, FormControl, FormErrorMessage, FormLabel, Input, Link, Text } from '@chakra-ui/react'
import { useInitResetPasswordMutation } from '@core/app/api/authApi'
import { nextForgotStep, setEmail } from '@core/app/slices/auth'
import { AppButton } from '@core/components/AppButton'
import { useAppTheme } from '@core/utils/contexts/ThemeContext/ThemeContext'
import { useAppDispatch } from '@core/utils/hooks/hook'
import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export const ForgotPassword = () => {
    const dispatch = useAppDispatch()
    const [initResetPassword] = useInitResetPasswordMutation()
    const { t } = useTranslation()
    const { executeRecaptcha } = useGoogleReCaptcha();
    const { appTheme } = useAppTheme()

    const sendEmailHandler = async (email: string, setSubmitting: Function, setStatus: Function) => {
        if (!executeRecaptcha) {
            console.error('ReCAPTCHA has not loaded yet');
            return;
        }
        const token = await executeRecaptcha('api_reset_password_init');

        if (token) {
            try {
                await initResetPassword({
                    data: {
                        email,
                        'g-recaptcha-response': token,
                    },
                }).unwrap()

                dispatch(setEmail(email))
                dispatch(nextForgotStep('emailValidation'))
            } catch (error: any) {
                if (error?.status === 422) {
                    const apiMessage = error?.data?.message || 'Invalid Recaptcha. Please, reload the page and try again.'
                    setStatus({ email: apiMessage })
                } else {
                    const errorMessage = error.data?.errors?.email[0] || 'An error occurred'
                    setStatus({
                        email: errorMessage,
                    })
                }

            } finally {
                setSubmitting(false)
            }
        }
    }

    return (
        <Flex flexDirection={'column'}>
            <Text fontSize={'xs'} color={'text.thirdly'} mb={1}>
                {t('6593')} 1 {t('1165')} 4
            </Text>
            <Text fontSize={'2xl'} color={'text.main'} fontWeight={'semibold'} mb={4}>
                {t('6586')}?
            </Text>
            <Text fontSize={'sm'} color={'#404040'} mb={6}>
                {t('10581', 'Enter your email and we’ll send you a code to reset your password')}.
            </Text>
            <Formik
                initialValues={{
                    email: '',
                }}
                validationSchema={Yup.object({
                    email: Yup.string()
                        .required(`${t('6456')}`)
                        .email(`${t('6598')}`),
                })}
                onSubmit={(values, { setSubmitting, setStatus }) => {
                    setSubmitting(true)
                    sendEmailHandler(values.email, setSubmitting, setStatus)
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    status,
                    setStatus,
                }) => (
                    <Form onSubmit={handleSubmit} style={{ marginBottom: '0px' }}>
                        <FormControl mb={4} isInvalid={(!!errors.email && touched.email) || (status && !!status.email)}>
                            <FormLabel>
                                <Text fontSize={'xs'}>{t('92')}*</Text>
                            </FormLabel>
                            <Input
                                type={'email'}
                                name={'email'}
                                value={values.email}
                                onChange={(e) => {
                                    handleChange(e)
                                    setStatus({
                                        email: '',
                                    })
                                }}
                                onBlur={handleBlur}
                                placeholder={`${t('727')}`}
                            />
                            {status && status.email && (
                                <Text fontSize={'xs'} color={'text.error'} mt={1}>
                                    {status.email}
                                </Text>
                            )}
                            <FormErrorMessage>{errors.email && touched.email && errors.email}</FormErrorMessage>
                        </FormControl>
                        <FormControl mt={6} display={'flex'} justifyContent={'space-between'} gap={'8px'}>
                            <Link
                                href={'/login'}
                                display={'flex'}
                                alignItems={'center'}
                                justifyContent={'center'}
                                minHeight={'48px'}
                                minWidth={'120px'}
                                px={'24px'}
                                borderRadius={'48px'}
                                border={'1px solid #2F80ED'}
                                fontSize={'14px'}
                                lineHeight={'20px'}
                                fontWeight={'600'}
                                color={'#2F80ED'}
                                textDecoration={'none'}
                                _hover={{
                                    textDecoration: 'none',
                                    bg: '#2F80ED',
                                    color: 'text.white',
                                }}
                            >
                                {t('8782')}
                            </Link>
                            <AppButton
                                translate="no"
                                title={t('4862', 'Send code')}
                                type={'submit'}
                                isLoading={isSubmitting}
                                variant={'primary'}
                                minHeight={'48px'}
                                minWidth={'120px'}
                            />
                            {/* <Button
                                type={'submit'}
                                disabled={isSubmitting}
                                variant={'primary'}
                                w={'120px'}
                                h={'44px'}
                                bg={appTheme ? `#${appTheme.newSettings.general.ButtonBackground}` : 'btn.primary'}
                                color={appTheme ? `#${appTheme.newSettings.general.ButtonText}` : 'text.white'}
                            >
                                {t('6626')}
                            </Button> */}
                        </FormControl>
                    </Form>
                )}
            </Formik>
        </Flex>
    )
}
